<template>
  <div id="app">
    <PageError @toggleSidebar="toggleSidebar"/>
    <BaseFooter :is-sidebar-opened="isSidebarOpened"/>
  </div>
</template>

<script>
  import PageError from '@/components/pages/page-error/PageError';
  import { setDocumentDescription } from '@/util/htmlDocument';
  import BaseFooter from '@/components/common/base-footer/BaseFooter';

  export default {
    name: 'ThePageError',
    components: {
      PageError,
      BaseFooter
    },
    data() {
      return {
        isSidebarOpened: null
      }
    },
    created() {
      this.$store.dispatch('common/getInfo');
      this.$store.dispatch('common/getAllVendors');
      document.title = 'Error Page';
    },
    methods: {
      toggleSidebar(sidebarState) {
        this.isSidebarOpened = sidebarState
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/page-error/ThePageError.vue